/* import __COLOCATED_TEMPLATE__ from './lightweight-header-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();